/**
 * RealAnalyticsProvider - PostHog wrapper
 *
 * Wraps PostHog to track flow events and page views.
 */

import { AnalyticsProvider } from '../types';

type PostHogInstance = {
  capture: (eventName: string, properties?: Record<string, any>) => void;
  identify: (userId: string, traits?: Record<string, any>) => void;
};

export class RealAnalyticsProvider implements AnalyticsProvider {
  private posthog: PostHogInstance | null;

  constructor(posthog?: PostHogInstance | null) {
    this.posthog = posthog || null;
  }

  track(eventName: string, properties?: Record<string, any>): void {
    if (this.posthog) {
      this.posthog.capture(eventName, properties);
    }
  }

  trackPageView(pageName: string, properties?: Record<string, any>): void {
    if (this.posthog) {
      this.posthog.capture('$pageview', { page: pageName, ...properties });
    }
  }

  identify(userId: string, traits?: Record<string, any>): void {
    if (this.posthog) {
      this.posthog.identify(userId, traits);
    }
  }
}
